import styled from 'styled-components';

export const DoubleNumbers = styled.div`
  display: flex;
  width: 66%;
  div:first-child {
    margin-right: 15px;
  }
`;

export const BorderBox = styled.div<{ $noBorder?: boolean }>`
  padding-bottom: 15px;
  border-bottom: ${({ theme, $noBorder }) => ($noBorder ? 'none' : `1px solid ${theme.black.a1}`)};
`;

export const FormSectionWrapper = styled.div`
  margin-top: 30px;
`;

export const FormInner = styled.div``;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const ButtonSection = styled.div`
  padding: 30px;
  display: flex;
  justify-content: flex-end;
  margin: 0 -30px -30px -30px;
  > div {
    margin-left: 10px;
  }
`;

export const SubInfo = styled.div`
  margin-left: 35px;
  color: ${({ theme }) => theme.baseBlue.a6};
  display: flex;
  span {
    margin-left: 5px;
  }
  div {
    margin-top: 5px;
    flex-shrink: 0;
  }
`;
